import {
    QuestionnaireFormData,
    getQuestionnaireItemFieldKey,
    isQuestionnaireItemRequired,
    questionnaireAnswerIsMissing,
} from 'common';
import { z } from 'zod';

const QuestionnaireAnswerSchema = z.union([z.string(), z.boolean()]);

export const QuestionnaireSimEntrySchema = z.object({
    businessDocSubTypeId: z.number(),
    answers: z.record(z.string(), QuestionnaireAnswerSchema),
});

export const QuestionnaireSimSchema = z.array(QuestionnaireSimEntrySchema);

export type QuestionnaireSimEntry = z.infer<typeof QuestionnaireSimEntrySchema>;

export function createEmptyQuestionnaireAnswers(businessDocSubTypeId: number): QuestionnaireSimEntry {
    return {
        businessDocSubTypeId,
        answers: {},
    };
}

export function buildQuestionnairesArraySchema(questionnaires: QuestionnaireFormData[]) {
    return QuestionnaireSimSchema.superRefine((entries, ctx) => {
        entries.forEach((entry, entryIndex) => {
            const questionnaire = questionnaires.find(
                (q) => q.businessDocTypeViewModel.BusinessDocSubTypeId === entry.businessDocSubTypeId
            );
            if (!questionnaire) {
                return;
            }

            questionnaire.items.forEach((item, itemIndex) => {
                if (!isQuestionnaireItemRequired(item)) {
                    return;
                }

                const fieldKey = getQuestionnaireItemFieldKey(itemIndex);
                const value = entry.answers[fieldKey];

                if (questionnaireAnswerIsMissing(value)) {
                    ctx.addIssue({
                        path: [entryIndex, 'answers', fieldKey],
                        code: z.ZodIssueCode.custom,
                        message: 'This field is required',
                    });
                }
            });
        });
    });
}
